import actions from './actions';
import initialState from '../initialState';

export const brokerReducer = (state = initialState.brokerState, action) => {
    switch (action.type) {
        case actions.OPEN_BROKER_MODAL:
            return { ...state, openBrokerModal: action.state.openBrokerModal };
        case actions.BROKER_ID_STATE:
            return { ...state, brokerId: action.state.brokerId };
        case actions.SET_DELETE_INCOMPLETE_REGISTERED_BROKER_MODAL:
                return {
                    ...state,
                    deleteIncompleteRegisteredBrokerModal: action.state.deleteIncompleteRegisteredBrokerModal,
                };
        default:
            return state;
    }
};

export default brokerReducer;
